module.exports = __webpack_public_path__ + "static/media/business-partner.36289f58.jpeg";